import React from 'react';
import { Link } from 'react-router-dom';
import { Dropdown } from 'react-bootstrap';
import team3 from 'assets/img/team/avatar.png';
// import team3 from 'assets/img/team/3.jpg';
import Avatar from 'components/common/Avatar';
import {
  // setIdEmpresa,
  // setNomeEmpresa,
  // setNomeUsuario,
  // setIdUsuario,
  // setEmailUsuario,
  // setNivelUsuario,
  // setExisteImportacao,
  // setExisteExportacao,
  // setExisteEmbarque,
  logout
} from 'helpers/auth';

const ProfileDropdown = () => {
  const logoutProfile = () => {
    logout();
    // setIdUsuario(0);
    // setNomeUsuario('');
    // setEmailUsuario('');
    // setIdEmpresa(0);
    // setNomeEmpresa('');
    // setNivelUsuario(0);
    // setExisteImportacao(false),
    //   setExisteExportacao(false),
    //   setExisteEmbarque(false);
  };

  return (
    <Dropdown navbar={true} as="li">
      <Dropdown.Toggle
        bsPrefix="toggle"
        as={Link}
        to="#!"
        className="pe-0 ps-2 nav-link"
      >
        <Avatar src={team3} />
      </Dropdown.Toggle>

      <Dropdown.Menu className="dropdown-caret dropdown-menu-card  dropdown-menu-end">
        <div className="bg-white rounded-2 py-2 dark__bg-1000">
          <Dropdown.Item as={Link} to="/" onClick={logoutProfile}>
            Sair
          </Dropdown.Item>
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default ProfileDropdown;
